module.exports = __webpack_public_path__ + "img/HION_INTRO_2020.1d7d220b.jpg";